<template>
    <div>
        <div v-if="!loading" class="_home-page">
          <!-- page 1 -->
          <div class="container">
            <div class="row bg" style="margin-top: 75px">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-2" style="width:20%">
                    <div class="qrcode ml-auto" style="float:left" ref="qrCodeUrl" id="qrCodeUrl"></div>
                  </div>
                  <div class="col-md-8" style="width:60%; text-align:center;">
                    <img alt="" style="width:35px;margin-bottom:5px" class="img-fluid" src="../../theme-assets/images/logo/cu_logo_black.png">
                    <h4 style="text-transform: unset;color:black;font-family: kalpurush;font-weight:bold;font-size:25px; margin-top: 5px;" align="center">চট্টগ্রাম বিশ্ববিদ্যালয়</h4>
                  </div>
                  <div class="col-md-2" style="width:20%;">
                    <!--img alt="mujib100" style="float: right; height:75px;margin-bottomx:5px" class="img-fluid" src="../../theme-assets/images/logo/mujib.png"-->
                  </div>
                </div>
              </div>
              <div class="col-md-12" style="margin-top:0px">
                  <p style="text-align:center;font-size: large;font-family: kalpurush;color:black;padding:10px"></p>
              </div>
              <div class="col-md-12">
                  <p style="text-align:center;font-size: 20px;font-weight:bold;font-family: kalpurush;color:black;padding:10px;margin-bottom:10px">১ম বর্ষ স্নাতক (সম্মান) কোর্সে ছাত্র-ছাত্রী ভর্তির মূল ফর্ম</p>
              </div>

              <div class="col-md-12" style="border-top: 2px solid darkgray; background: rgb(240, 240, 240);">&nbsp;</div>
              <div class="col-md-2 pl-4" style="text-align: left; background: rgb(240, 240, 240);">
                 <img alt="" style="height:180px; border: 1px solid darkgray; padding:1px; background: white;" class="img-fluid" :src="personal.photo">
              </div>
              <div class="col-md-7" style="text-align: left; background: rgb(240, 240, 240);">
                <p class="mt-3" style="font-size:18px; color:black; font-family: kalpurush;">
                  ভর্তির শিক্ষাবর্ষ : <span style="font-family:'Times New Roman', Times, serif"><strong>{{admission.session}}</strong></span>
                </p>
                <p class="mt-3" style="font-size:18px; color:black; font-family: kalpurush;">
                  বিষয় : <span style="font-family:'Times New Roman', Times, serif"><strong>{{admission.subject_name}}</strong></span>
                </p>
                <p class="mt-3" style="font-size:18px; color:black; font-family: kalpurush;">
                  কোর্সের নাম : <span style="font-family:'Times New Roman', Times, serif"><strong>{{admission.course}}</strong></span>
                </p>
                <p class="mt-3" style="font-size:18px; color:black; font-family: kalpurush;">
                  রেজিস্ট্রেশন/আই.ডি. নম্বর : <span style="font-family:'Times New Roman', Times, serif"><strong>{{admission.regino}}</strong></span>
                </p>
              </div>
              <div class="col-md-3 pr-3" style="text-align: left; background: rgb(240, 240, 240);">
                <p class="mt-3" style="font-size:14px; color:black; font-family: kalpurush; position: relative">
                  ভর্তি পরীক্ষার রোল: <strong>{{admission.exam_roll}}</strong> <span style="position: absolute; left:160px">(<strong>{{admission.unit}}</strong>)</span>
                </p>
                <p class="mt-3" style="font-size:14px; color:black; font-family: kalpurush;">
                  ভর্তি পরীক্ষায় প্রাপ্ত নম্বর : <span style="font-family:'Times New Roman', Times, serif"><strong>{{admission.exam_score}}</strong></span>
                </p>
                <!--p class="mt-3" style="margin-left: 75px; font-size:14px; color:black; font-family: kalpurush;">
                   প্রাপ্ত নম্বর : <span style="font-family:'Times New Roman', Times, serif"><strong>100.00</strong></span>
                </p-->
                <p class="mt-3" style="font-size:14px; color:black; font-family: kalpurush;">
                  জমাকৃত ভর্তি ফিসের পরিমাণ : <span style="font-family:'Times New Roman', Times, serif"><strong>{{admission.admission_fee}} Tk</strong></span>
                </p>
                <p class="mt-3" style="font-size:14px; color:black; font-family: kalpurush;">
                  ফিস জমাদানের রসিদ নম্বর : <span style="font-family:'Times New Roman', Times, serif"><strong>{{admission.memo_receipt}}</strong></span>
                </p>
                <p class="mt-3" style="font-size:14px; color:black; font-family: kalpurush;">
                  ফিস জমাদানের তারিখ : <span style="font-family:'Times New Roman', Times, serif"><strong>{{admission.payment_date}}</strong></span>
                </p>
              </div>
              <div class="col-md-12 mb-4" style="border-bottom: 2px solid darkgray; background: rgb(240, 240, 240);">&nbsp;</div>
              
              <div class="col-md-12" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">১.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    ছাত্র/ছাত্রীর পুরো নাম (বাংলায়): <strong>{{personal.name_bng}}</strong>
                  </div>
                  <div>
                    (ইংরেজিতে বড় অক্ষরে): <strong>{{personal.name}}</strong> 
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">২.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    জাতীয় পরিচয়পত্র বা জন্মনিবন্ধন নম্বর: <strong>{{personal.nid_brno}}</strong> 
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">৩.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    মোবাইল নম্বর: <strong>{{personal.mobile}}</strong> 
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">৪.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    (ক) পিতার নাম (বাংলায়): <strong>{{guardian.fname_bng}}</strong> 
                  </div>
                  <div style="margin-left: 25px;">
                    (ইংরেজিতে বড় অক্ষরে): <strong>{{guardian.fname}}</strong> 
                  </div>
                  <div>
                    (খ) পিতার জাতীয় পরিচয়পত্র (NID) নম্বর: <strong>{{guardian.fnid_brno}}</strong> 
                  </div>
                  <div>
                    (গ) পিতার বর্তমান পেশা, পদবী এবং প্রতিষ্ঠানের নাম ও ঠিকানা: 
                  </div>
                  <div style="margin-left: 45px;">
                    বর্তমান পেশা: <strong>{{guardian.foccupation}}</strong> 
                  </div>
                  <div style="margin-left: 45px;">
                    পদবী: <strong>{{guardian.fdesignation}}</strong> 
                  </div>
                  <div style="margin-left: 45px;">
                    প্রতিষ্ঠানের নাম ও ঠিকানা: <strong>{{guardian.femployer_info}}</strong> 
                  </div>
                  <div>
                    (ঘ) পিতার মোবাইল নম্বর: <strong>{{guardian.fmobile}}</strong> 
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">৫.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    (ক) মাতার পুরো নাম (বাংলায়): <strong>{{guardian.mname_bng}}</strong> 
                  </div>
                  <div style="margin-left: 25px;">
                    (ইংরেজিতে বড় অক্ষরে): <strong>{{guardian.mname}}</strong> 
                  </div>
                  <div>
                    (খ) মাতার জাতীয় পরিচয়পত্র (NID) নম্বর: <strong>{{guardian.mnid_brno}}</strong> 
                  </div>
                  <div>
                    (গ) মাতার মোবাইল নম্বর: <strong>{{guardian.mmobile}}</strong> 
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">৬.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    বৈবাহিক অবস্থা: <strong>{{personal.is_married?'বিবাহিত':'অবিবাহিত'}}</strong> 
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">৭.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    যদি বিবাহিত হন স্বামী/স্ত্রীর নাম, ঠিকানা এবং টেলিফোন/মোবাইল নম্বর: 
                  </div>
                  <div style="margin-left: 45px;">
                    স্বামী/স্ত্রীর নাম: <strong>{{personal.spouse_name}}</strong> 
                  </div>
                  <div style="margin-left: 45px;">
                    যোগাযোগের ঠিকানা: <strong>{{personal.spouse_address}}</strong> 
                  </div>
                  <div style="margin-left: 45px;">
                    টেলিফোন/মোবাইল নম্বর: <strong>{{personal.spouse_mobile}}</strong> 
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">৮.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    স্থায়ী ঠিকানা: 
                  </div>
                  <div style="margin-left: 45px;">
                    বাড়ি / হোল্ডিং নম্বর: <strong>{{ personal.both_address_same ? personal.present_house : personal.permanent_house  }}</strong>,
                    গ্রাম / ওয়ার্ড / সড়ক: <strong>{{personal.both_address_same ?personal.permanent_village : personal.permanent_village }}</strong>, 
                    ডাকঘর: <strong>{{replaceUnderscores(personal.both_address_same ? personal.permanent_poffice : personal.permanent_poffice)}}</strong>, 
                    থানা/উপজেলা: <strong>{{replaceUnderscores(personal.permanent_thana ? personal.permanent_thana : personal.permanent_thana)}}</strong>, 
                    জেলা: <strong>{{replaceUnderscores(personal.permanent_district ? personal.permanent_district : personal.permanent_district)}}</strong> 
                  </div>
                  <div style="margin-left: 45px;">
                    মোবাইল নম্বর: <strong>{{personal.permanent_mobile}}</strong> 
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">৯.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    ছাত্র/ছাত্রীর সাথে যোগাযোগের বর্তমান ঠিকানা: 
                  </div>
                  <div style="margin-left: 45px;">
                    বাড়ি / হোল্ডিং নম্বর: <strong>{{personal.present_house }}</strong> ,
                    গ্রাম / ওয়ার্ড / সড়ক: <strong>{{personal.present_village}}</strong>, 
                    ডাকঘর: <strong>{{replaceUnderscores(personal.present_poffice)}}</strong>, 
                    থানা/উপজেলা: <strong>{{replaceUnderscores(personal.present_thana)}}</strong>, 
                    জেলা: <strong>{{replaceUnderscores(personal.present_district)}}</strong> 
                  </div>
                  <div style="margin-left: 45px;">
                    মোবাইল নম্বর: <strong>{{personal.present_mobile}}</strong> 
                  </div>
                  <div style="font-style: italic; color: red;">
                    বিশেষ দ্রষ্টব্যঃ বর্তমান ঠিকানা পরিবর্তন হলে এক সপ্তাহের মধ্যে বিভাগের সভাপতির মাধ্যমে বিশ্ববিদ্যালয়ের রেজিস্ট্রারকে লিখিতভাবে জানাতে হবে। 
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">১০.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    স্থানীয় অভিভাবকের নাম, ছাত্র/ছাত্রীর সাথে সম্পর্ক, ও বর্তমান ঠিকানা (টেলিফোন/মোবাইল নম্বরসহ):
                  </div>
                  <div style="margin-left: 45px;">
                    অভিভাবকের নাম: <strong>{{guardian.guardian_name}}</strong> 
                  </div>
                  <div style="margin-left: 45px;">
                    ছাত্র/ছাত্রীর সাথে সম্পর্ক: <strong>{{guardian.guardian_relation}}</strong> 
                  </div>
                  <div style="margin-left: 45px;">
                    অভিভাবকের বর্তমান ঠিকানা: <strong>{{guardian.guardian_address}}</strong> 
                  </div>
                  <div style="margin-left: 45px;">
                    অভিভাবকের টেলিফোন/মোবাইল নম্বর: <strong>{{guardian.guardian_mobile}}</strong> 
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">১১.</div>
                <div style="display: inline-block; width: 97%; position: relative;">
                  ধর্ম: <strong>{{personal.religion}}</strong>
                  <span style="position: absolute; left: 250px;">রক্তের গ্রুপ: <strong>{{personal.blood_group}}</strong></span>
                  <span style="position: absolute; left: 600px;">জাতীয়তা: <strong>{{personal.nationality}}</strong></span>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">১২.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    মাধ্যমিক স্কুল সার্টিফিকেট অনুযায়ী জন্ম তারিখ: <strong>{{personal.dob}}</strong> 
                  </div>
                </div>
              </div>
            </div>

            <!-- page 2 -->
            <p style="page-break-before: always">&nbsp;</p>
            <div class="row bg" style="margin-top: 75px">
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">১৩.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    বি.এন.সি.সি. প্রশিক্ষনে / রোভার স্কাউটে যোগদানে ইচ্ছুক কিনা: <strong>{{admission.interested_bncc ? 'হ্যাঁ' : 'না'}}</strong> 
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">১৪.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    পিতার/আইনতঃ অভিভাবকের আনুমানিক মাসিক আয় (বেতন, জমি-জমা ও ব্যবসাসহ মোট মাসিক আয় উল্লেখ করতে হবে): 
                  </div>
                  <div style="margin-left: 45px;">
                    মাসিক আয় (সংখ্যায়): <strong>{{admission.guardian_income_number}}/= Tk</strong>
                    <span style="margin-left: 150px;">মাসিক আয় (কথায়): <strong>{{admission.guardian_income_word}} Taka Only</strong></span>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush; ">
                <div style="display: inline-block; width: 3%; vertical-align: top;">১৫.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    আবেদনকারী যে সকল শিক্ষা প্রতিষ্ঠান হতে যে যে পরীক্ষায় উত্তীর্ণ বা অংশগ্রহন করেছেন তার বিবরণ 
                  </div>
                  <div style="margin-left: 25px;">
                    <table class="table mt-2 mb-2" border="1" style="align:center; margin:auto">
                      <tr class="table-info">
                        <th class="count-desc">পরীক্ষার নাম</th>
                        <th class="count-desc text-left">শিক্ষা প্রতিষ্ঠানের নাম</th>
                        <th class="count-desc text-center">বিশ্ববিদ্যালয় বা শিক্ষাবোর্ডের নাম (কেন্দ্রের নাম ও পরীক্ষার রোলসহ)</th>
                        <th class="count-desc text-center">পাশের সন</th>
                        <th class="count-desc text-center">অর্জিত জিপিএ</th>
                      </tr>
                      <tr>
                        <td class="count-desc">SSC/Equivalent</td>
                        <td class="count-desc text-left"><strong>{{academic.ssc_institute}}</strong></td>
                        <td class="count-desc text-center"><strong>{{academic.ssc_board}}</strong> (কেন্দ্র - <strong>{{academic.ssc_center}}</strong> , রোল নং - <strong>{{academic.ssc_roll}}</strong>)</td>
                        <td class="count-desc text-center"><strong>{{academic.ssc_year}}</strong></td>
                        <td class="count-desc text-center"><strong>{{academic.ssc_gpa}}</strong></td>
                      </tr>
                      <tr>
                        <td class="count-desc">HSC/Equivalent</td>
                        <td class="count-desc text-left"><strong>{{academic.hsc_institute}}</strong></td>
                        <td class="count-desc text-center"><strong>{{academic.hsc_board}}</strong> (কেন্দ্র - <strong>{{academic.hsc_center}}</strong> , রোল নং - <strong>{{academic.hsc_roll}}</strong>)</td>
                        <td class="count-desc text-center"><strong>{{academic.hsc_year}}</strong></td>
                        <td class="count-desc text-center"><strong>{{academic.hsc_gpa}}</strong></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">১৬.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    এ বিশ্ববিদ্যালয়ে বা অন্য কোন বিশ্ববিদ্যালয়ে বা কোন কলেজ/শিক্ষা প্রতিষ্ঠানে কোন কোর্সে ভর্তির পূর্বে ভর্তি হওয়ার পর ভর্তি ও রেজিস্ট্রেশনের মেয়াদ বহাল থাকলে বিবরণ উল্লেখ করতে হবে অথবা এ বিশ্ববিদ্যালয়ে ১ম বর্ষে প্রথম ভর্তির নিম্নোক্ত বিবরণ উল্লেখ করতে হবে : <strong>{{xadmission.is_admitted ? '' : 'প্রযোজ্য নহে।'}}</strong>
                  </div>
                  <div>
                    (ক) কোর্সের নাম : <strong>{{xadmission.admitted_course}}</strong> 
                  </div>
                  <div>
                    (খ) বিশ্ববিদ্যালয়/শিক্ষাপ্রতিষ্ঠানের নাম: <strong>{{xadmission.admitted_institute}}</strong> 
                  </div>
                  <div style="position: relative;">
                    (গ) শিক্ষাবর্ষ: <strong>{{xadmission.admitted_session}}</strong>
                    <span style="left: 300px; position: absolute;">বিষয়: <strong>{{xadmission.admitted_subject}}</strong></span>
                  </div>
                  <div style="position: relative;">
                    (ঘ) ক্লাশ রোল নম্বর: <strong>{{xadmission.admitted_classroll}}</strong>
                    <span style="left: 300px; position: absolute;">রেজিস্ট্রেশন/আই.ডি. নম্বর: <strong>{{xadmission.admitted_regino}}</strong></span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">১৭.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    <span style="color:red;">একজন ছাত্র/ছাত্রীর একাধিক কোর্সে ভর্তি (<strong>দ্বৈত ভর্তি</strong>) হওয়া অপরাধ।</span> এ ভর্তির পূর্বের সকল ভর্তি দশ দিনের মধ্যে বাতিলের আদেশপত্র ভর্তি ফর্ম এর সাথে সংযুক্ত করে দিতে হবে। <span style="color:red;">বিশ্ববিদ্যালয়ের নিয়মে দ্বৈত ভর্তি হলে তার সকল ভর্তি অবৈধ হিসাবে গণ্য হবে এবং তাকে অন্যান্য শাস্তিও ভোগ করতে হবে।</span>
                  </div>
                  <div>
                    (ক) অধ্যয়ন স্থগিত থাকলে তার কারণ উল্লেখ করতে হবে: <b>{{xadmission.is_postponed ? '' : 'প্রযোজ্য নহে।'}}</b> 
                  </div>
                  <div style="margin-left: 25px;">
                    স্থগিত থাকার কারণ: <b>{{xadmission.is_postponed ? xadmission.postponed_reason : '&nbsp;'}}</b> 
                  </div>
                  <div>
                    (খ) এ বিশ্ববিদ্যালয় বা বা অন্য কোন বিশ্ববিদ্যালয় বা কোন কলেজ/শিক্ষা প্রতিষ্ঠান হতে কোন কারণে বহিষ্কৃত হয়েছে কিনা: <strong>{{xadmission.is_expeled ? '' : 'প্রযোজ্য নহে।'}}</strong> 
                  </div>
                  <div>
                    (গ) বহিস্কৃত হবার কারণ: <strong>{{xadmission.is_expeled ? xadmission.expeled_reason : ''}}</strong> 
                  </div>
                  <div>
                    (ঘ) বিশ্ববিদ্যালয়/শিক্ষাপ্রতিষ্ঠানের নাম ও বহিস্কারের মেয়াদ: <strong>{{xadmission.is_expeled ? xadmission.expeled_institute + ', মেয়াদঃ ' + xadmission.expeled_period : ''}}</strong> 
                  </div>
                  <div>
                    (ঙ) পরীক্ষায় অসদুপায় অবলম্বনের কারণে বহিস্কৃত হলে বিষয়সহ পরীক্ষার নাম, পরীক্ষার বছর, পরীক্ষার রোল নম্বর, বহিস্কারের মেয়াদ, রেজিস্ট্রেশন/আই.ডি. নম্বর ইত্যাদি উল্লেখ করতে হবে:
                  </div>
                  <div style="margin-left: 45px;">
                    <strong>{{xadmission.expeled_examinfo ? xadmission.expeled_examinfo : '&nbsp;'}}</strong> 
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">১৮.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    বিশ্ববিদ্যালয়ের আবাসিক হল এ থাকার ব্যবস্থা না হলে যেখানে থেকে লেখাপড়া করবেন তার ঠিকানা (টেলিফোন/মোবাইল নম্বরসহ): <strong>{{admission.self_residence ? '' : 'প্রযোজ্য নহে।'}}</strong>
                  </div>
                  <div style="margin-left: 45px;">
                    আবাসস্থলের ঠিকানা: <strong>{{admission.residence_address}}</strong>
                  </div>
                  <div style="margin-left: 45px;">
                    মোবাইল নম্বর: <strong>{{admission.residence_mobile}}</strong> 
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">১৯.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    পুনঃভর্তি হলে তার বিবরণ: <strong>{{xadmission.is_readmitted ? '' : 'প্রযোজ্য নহে।'}}</strong>
                  </div>
                  <div style="margin-left: 45px;">
                    <strong>{{xadmission.is_readmitted ? xadmission.readmission_reason : '&nbsp;'}}</strong>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">২০.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    কোন চাকরিজীবী এ বিশ্ববিদ্যালয়ে ভর্তি হতে হলে তাকে তার চাকরির নিয়োগকারীর কাছ থেকে অবশ্যই ভর্তি হওয়ার অনুমতি ও ছুটি মঞ্জুরীর লিখিত অনুমতিপত্র এবং চাকরি হতে রিলিজ অর্ডার (ছাড়পত্র) গ্রহণ করতে হবে এবং মুল অনুমতি ও ছাড়পত্রের (রিলিজ অর্ডার) উপর সংশ্লিষ্ট বিভাগীয় সভাপতির লিখিত সুপারিশ ভর্তি ফরমের সাথে সংযুক্ত করে দিতে হবে। অন্যথায় তাকে ভর্তি করা হবে না। যদি ভর্তির সময় সংশ্লিষ্ট ছাত্র/ছাত্রী চাকুরিরত না থাকেন কিন্তু ভর্তির পর চাকুরি লাভ করেন তাহলেও এ বিশ্ববিদ্যালয়ে লেখাপড়া করার জন্য অনুরূপভাবে নিয়োগকারীর কাছ থেকে লিখিত অনুমতিপত্র ও ছুটি মঞ্জুরীর চিঠি এবং রিলিজ অর্ডার নিতে হবে। যদি এ ধরনের কোন তথ্য গোপন করে বা মিথ্যা তথ্য প্রদান করে কেউ ভর্তি হন, তা হলে তার ভর্তি বাতিল করা হবে এবং এজন্য তাকে অন্যান্য শাস্তিও ভোগ করতে হবে। চাকুরিরত হলে পদবী, প্রতিষ্ঠানের নাম ও ঠিকানা এবং নিয়োগকারীর পদবীসহ ঠিকানা উল্লেখ করতে হবে: <strong>{{personal.is_employee ? '' : 'প্রযোজ্য নহে।'}}</strong>
                  </div>
                  <div style="margin-left: 45px;">
                    চাকুরির বিবরন: <strong>{{personal.is_employee ? personal.job_description : ''}}</strong> 
                  </div>
                  <div style="margin-left: 45px;">
                     নিয়োগকারীর পদবী: <strong>{{personal.is_employee ? personal.employer_details : ''}}</strong>, ঠিকানা: <strong>{{personal.is_employee ? personal.employer_address : ''}}</strong>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width: 3%; vertical-align: top;">২১.</div>
                <div style="display: inline-block; width: 97%;">
                  <div>
                    <strong>বিশেষ নির্দেশনা</strong> : নিম্নলিখিত সনদপত্র (সার্টিফিকেট) এবং ভর্তির প্রয়োজনীয় অন্যান্য দলিলপত্রাদির ফটোকপি শিক্ষক বা গেজেটেড কর্মকর্তা দ্বারা সত্যায়িত করে এই ফরমের সংগে সংযুক্ত করে দিতে হবে। অন্যথায় ভর্তি করা হবে না। 
                  </div>
                  <div>
                    (ক) সংশ্লিষ্ট শিক্ষাবোর্ড কতৃক ইস্যুকৃত মাধ্যমিক ও উচ্চ মাধ্যমিক বা সমমানের পরীক্ষা পাশের ট্রান্সক্রিপ্ট/গ্রেডশীট/নম্বরফর্দের সত্যায়িত ফটোকপি। 
                  </div>
                  <div>
                    (খ) আবেদনকারীর সাম্প্রতিক তোলা তিন কপি পাসপোর্ট সাইজের সত্যায়িত ছবি। 
                  </div>
                  <div>
                    (গ) আই.ডি. কার্ড/রেজিস্ট্রেশন কার্ড/মাইগ্রেশন সার্টিফিকেট এর সত্যায়িত ফটোকপি (যার জন্য প্রযোজ্য)। 
                  </div>
                  <div>
                    (ঘ) ট্রান্সফার সার্টিফিকেট এর সত্যায়িত ফটোকপি (যার জন্য প্রযোজ্য)। 
                  </div>
                </div>
              </div>
            </div>
            
            <!-- page 3 -->
            <p style="page-break-before: always">&nbsp;</p>
            <div class="row bg" style="margin-top: 75px">
              <div class="col-md-12" style="margin-top: 40px; margin-bottom: 40px;">
                <div style="text-align:center;font-size: 20px;font-weight:bold;font-family: kalpurush;color:black;padding:10px;margin-bottom:10px">অঙ্গীকারপত্র</div>
              </div>
              
              <div class="col-md-12 mt-2" style="font-size:16px; color:black; font-family: kalpurush;">
                <div>
                  এতদ্বারা আমি ঘোষনা করছি যে, আমি এই ভর্তি ফরম নিজে সম্পূর্ণ পড়েছি এবং নিজ হাতে এই ভর্তি ফরম পূরণ করেছি। এই ভর্তি ফরমে প্রদত্ত সমস্ত বিবরন সত্য। আমি অঙ্গীকার করছি যে, 
                </div>
                <div class="mt-2 ml-3 mr-2">
                  (ক) আমি এই বিশ্ববিদ্যালয়ের এবং হলের আবাসিক বা অনাবাসিক ছাত্র/ছাত্রী হিসেবে চট্টগ্রাম  বিশ্ববিদ্যালয়ের সমস্ত নিয়ম ও বিধি মেনে চলব এবং বিশ্ববিদ্যালয়ের শান্তি-শৃঙ্খলা বা আদেশের পরিপন্থী কোন কাজ করবো না। যদি এই ধরনের কোন কাজ করি তবে বিশ্ববিদ্যালয় কর্তৃপক্ষ যে শাস্তি প্রদান করবেন তা বিনা আপত্তিতে মেনে নিতে বাধ্য থাকব। 
                </div>
                <div class="mt-2 ml-3 mr-2">
                  (খ) যদি জাল বা ঘষামাজা করা কোন মার্কশীট বা সার্টিফিকেট বা দলিলপত্র দাখিল করার জন্য কিংবা প্রয়োজনীয় তথ্য গোপন বা মিথ্যা তথ্য প্রদান বা দ্বৈত ভর্তি হওয়ার কারণে আমি দোষী সাব্যস্ত হই তাহলে আমার ভর্তি বিশ্ববিদ্যালয় কতৃপক্ষ বাতিল করতে পারবেন। এছাড়া এই ব্যাপারে বিশ্ববিদ্যালয় কর্তৃপক্ষ অন্য যে কোন শাস্তি প্রদান করলে আমি মেনে নিতে বাধ্য থাকব। 
                </div>
                <div class="mt-2 ml-3 mr-2">
                  (গ) ছাত্র/ছাত্রী হিসেবে আমার বিশ্ববিদ্যালয়ের ছাত্রত্ব সম্পর্কিত কোন বিষয়ে আমি চট্টগ্রাম  বিশ্ববিদ্যালয়ের অ্যাক্ট ১৯৭৩ এর বিধানসমূহ, জরুরী আইনসমূহ অথবা সময়ে সময়ে প্রনীত বিধিসমূহ অথবা সিন্ডিকেট/একাডেমিক কাউন্সিল অথবা উপাচার্য/উপ-উপাচার্য/অনুষদের ডিনবৃন্দ কিংবা উক্ত বিষয়ে ভারপ্রাপ্ত কোন বিভাগীয় সভাপতি বা ইন্সটিটিউটের পরিচালক বা হলের প্রভোস্ট/প্রক্টর, বিশ্ববিদ্যালয়ের শিক্ষক/কর্মকর্তার সিদ্ধান্ত চুড়ান্ত বলে মেনে নিতে বাধ্য থাকব এবং এতে কোন ওজর আপত্তি করবো না। 
                </div>
                <div class="mt-2 ml-3 mr-2">
                  (ঘ) বিশ্ববিদ্যালয়ে অধ্যয়নকালীন ও হলে অবস্থানকালীন সময়ে বিশ্ববিদ্যালয় কর্তৃপক্ষ প্রণিত ছাত্র-ছাত্রীদের অবশ্যই পালনীয় আচরণবিধি/সাধারণ ও সুনির্দিষ্ট নীতিমালার পরিপন্থী কোন কার্যকলাপে লিপ্ত থাকব না। 
                </div>
                <div class="mt-2 ml-3 mr-2">
                  (ঙ) এই অঙ্গীকারপত্র স্বজ্ঞানে স্বাক্ষর দিলাম এবং আমার পিতা/মাতা/স্বামী/আইনতঃ অভিভাবক স্বহস্তে স্বাক্ষর/টিপসই দান করেছেন।  
                </div>
              </div>

              <div class="col-md-12 mt-5 pt-5" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width:70%; vertical-align: top;">
                  <div>_______________________________________</div>
                  <div>&nbsp;&nbsp;(পিতা/মাতা/স্বামী/আইনতঃ অভিভাবকের স্বাক্ষর)</div>
                  <div class="mt-2">তারিখঃ _____/_____/_________</div>
                </div>
                <div style="display: inline-block; width: 30%; vertical-align: top;">
                  <div>_____________________________________</div>
                  <div>&nbsp;&nbsp;(আবেদনকারীর পুরো নামের স্বাক্ষর - বাংলায়) </div>
                  <div class="mt-2">তারিখঃ _____/_____/_________</div>
                </div>                
              </div>

              <div class="col-md-12 mt-5 mb-5 pt-5" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width:70%; vertical-align: top;">
                  <div class="mt-2">বিভাগীয় সভাপতির মন্তব্যঃ __________________</div>
                  <div class="mt-2">_______________________________________</div>
                  <div class="mt-2">_______________________________________</div>
                  <div class="mt-3"><strong>সভাপতি</strong>, __________________________ বিভাগ</div>
                  <div class="mt-5">_______________________________________</div>
                  <div class="pl-3">&nbsp;&nbsp;(বিভাগীয় সভাপতির অফিস সীলসহ স্বাক্ষর)</div>
                  <div class="mt-2">তারিখঃ _____/_____/_________</div>
                  <div class="mt-1" style="width: 40%; font-size:13px; font-style:italic;">ভর্তির প্রয়োজনীয় সমস্ত মূল দলিলপত্রাধি যাচাইকৃত ও সঠিক আছে এবং ভর্তির নির্ধারিত সময়ও আছে। বিশ্ববিদ্যালয়ের নিয়ম অনুযায়ী সে ভর্তির যোগ্য।</div>
                </div>
                <div style="display: inline-block; width: 30%; vertical-align: top;">
                  <div class="mt-2">হল প্রভোস্টের মন্তব্যঃ ______________________</div>
                  <div class="mt-2">_______________________________________</div>
                  <div class="mt-2">_______________________________________</div>
                  <div class="mt-3"><strong>প্রভোস্ট</strong>, ____________________________ হল</div>
                  <div class="mt-5">_______________________________________</div>
                  <div class="pl-3">&nbsp;&nbsp;&nbsp;&nbsp;(হল প্রভোস্টের অফিস সীলসহ স্বাক্ষর)</div>
                  <div class="mt-2">তারিখঃ _____/_____/_________</div>
                </div>                
              </div>

              <div class="col-md-12 mt-5 pt-5" style="font-size:16px; color:black; font-family: kalpurush;">
                <div style="display: inline-block; width:35%; vertical-align: top;">
                  <div>________________________________</div>
                  <div><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ভর্তি সংশ্লিষ্ট সহকারীর স্বাক্ষর</strong></div>
                  <div class="mt-2"></div>
                </div>
                <div style="display: inline-block; width: 35%; vertical-align: top;">
                  <div>________________________________</div>
                  <div><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;সহকারী রেজিস্ট্রার (একাডেমিক)</strong></div>
                  <div class="mt-2">&nbsp;&nbsp;&nbsp;রেজিস্ট্রার দপ্তর, চট্টগ্রাম  বিশ্ববিদ্যালয়</div>
                </div>
                <div style="display: inline-block; width: 30%; vertical-align: top;">
                  <div>________________________________</div>
                  <div><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ডেপুটি রেজিস্ট্রার (একাডেমিক)</strong></div>
                  <div class="mt-2">&nbsp;&nbsp;&nbsp;রেজিস্ট্রার দপ্তর, চট্টগ্রাম  বিশ্ববিদ্যালয়</div>
                </div>                
              </div>

              <div class="col-md-12 mt-4 pt-4" style="vertical-align: bottom;">
                <span style="font-style:italic;">Powered by <b>ICT Cell, University of Chittagong</b></span>
              </div>
                
            </div>
          
          </div>
        </div>
        <div v-else>
            <loader class="loader"></loader> <br />
        </div>
        
    </div>
</template>

<script>
import Loader from '../Helper/Loader'
import Banner from '../Partial/Banner'
import { GET_SIF_CARD, CHECK_SIF_CARD } from '../../const/api'
import { GET } from '../../utils/Request'
import QRCode from 'qrcodejs2'
export default {
  name: 'PrintSIF',
  components: { Loader, Banner },
  data() {
    return {
        loading: false,
        Schedule:'',
        firstTimeLoad: true,
        qrText:'',

        personal : {},
        academic : {},
        guardian : {},
        admission : {},
        xadmission : {},

        studentInfo:{
          applicant_no: '',
          co_ordinator_signature: '',
          exam_date: '',
          exam_roll: '',
          exam_time: '',
          father_name: '',
          group: '',
          mother_name: '',
          name: '',
          photo: '',
          status: '',
          unit_co_ordinator: '',
          medium:'',
          admitcard_download_date:'',
          admitcard_download_time:'',
        } 
    }
  },
  computed: {
    isOnHomepage() {
      let routeName = this.$route.name
      return routeName == 'home' ? true : false
    }
  },
  created() {
    this.getDocs();
  },
  mounted() { 
  },
  methods: {

    replaceUnderscores(text) {
      if (!text) return '';
      return String(text).replace(/_/g, ' ');
    },
    
    async getDocs() {
    
      /*console.log(this.$route.params);*/

      if(this.$route.params.hash_key)
        var data = await GET(CHECK_SIF_CARD + this.$route.params.hash_key);
      else
        var data = await GET(GET_SIF_CARD);

      //console.log(data.data);

      if(data.data.status=='success'){
        this.personal = data.data.personal;
        this.academic = data.data.academic;
        this.guardian = data.data.guardian;
        this.admission = data.data.admission;
        this.xadmission = data.data.xadmission;

        /*this.studentInfo.unit_co_ordinator = data.data.unit_co_ordinator;
        this.studentInfo.co_ordinator_signature = data.data.co_ordinator_signature;*/

        this.qrText = `${process.env.VUE_APP_FRONTEND_URL}check-sif/${this.admission.hash_key}`;
        /*this.qrText = 'http://dev.front.cu.ac.bd/check-sif/' + this.admission.hash_key;*/

      }
      else{
        this.$iziToast.error({
            /*message: data.data.message */
        });
        this.goForUrl('/');
      }
      this.timeoutForLoading();
    },
    
    goForUrl(url) {
      this.$router.replace(url)
    },
    
    topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    },
    timeoutForLoading() {
      if (this.firstTimeLoad) {
        this.$nextTick(() => {
          setTimeout(
            function() {
              this.loading = false;
              this.getQR();
              /*window.print();*/
            }.bind(this),
            3000
          )
        })
      }
      this.firstTimeLoad = false
    },
    getQR(){
       /*console.log(this.qrText);*/

       let canvasDiv = document.createElement("div"); //New dom element, if there is only one page, you can use the page element directly
        canvasDiv.id = 'canvas'
        document.getElementById('qrCodeUrl').append(canvasDiv);
        let qrcode = new QRCode('canvas', { //qrcode generates QR code
          text: this.qrText,
          width: 75,
          height: 75,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
        let canvas = document.getElementById('canvas').querySelector('canvas') //Get the canvas element
        var dataURL = canvas.toDataURL(); 
        canvas = null; 
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.pbreak {
  page-break-before: always|important; 
}

.bg {
  /* The image used */
  background-image: url("../../theme-assets/images/logo/cu_bg_logo.png");

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.loader {
  margin-top: 20%;
}
.pdf-app{
  width:100%;
  height:182.5vh;
}
.d-flex{
  padding:10px;
  margin:10px;
  -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
    box-shadow: 1px 0 15px 2px #c1b3b3;
}
.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid{
  max-width:100%;
}


/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
   box-sizing: border-box;
}

</style>
